export const DRAWER_WIDTH = 240;
export const PRIMARY_COLOR = '#20184b';


// WEBPACK FOOTER //
// ./src/modules/Layout/LayoutConstants.js